<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SITE_ABBR')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-3">
            <cmp-site-select
              ref="siteSelect"
              :pageId="this.$options.name"
              :selected="frame0.selectedCode.COD_SITE"
              @list-clicked="setOptionList('site',$event)"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DSRT_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-custom-select
              ref="jobDistrict"
              :selected="frame0.selectedCode.COD_DSRT"
              :initialSelectedIndex="0"
              :defaultOption="'all'"
              :optionList="optionList.COD_DSRT"
              @list-clicked="setOptionList('jobDistrict',$event)"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BUIL_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-custom-select
              ref="building"
              :selected="frame0.selectedCode.COD_BUIL"
              :initialSelectedIndex="0"
              :defaultOption="'all'"
              :optionList="optionList.COD_BUIL"
              @list-clicked="setBulidId"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_LCT_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="frame0.locationName"
              maxlength="50"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_LCT_EN_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="frame0.locationEnglishName"
              maxlength="50"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USE_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-yn-select
              ref="useYn"
              :initialSelectedIndex="0"
              :selected="frame0.selectedCode.COD_USE"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            v-permission:read="$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsLocation'"
        :showDisplayCountControl="false"
        :initial-pagesize="10"
        @cellclick="onClickGrid($event)"
      >
        <div class="btn_wrapR">
          <sui-button
            v-permission:create="this.$options.name"
            type="button"
            class="comm_btn_gridTop"
            @click="callPopup('isShownAddPopup')"
          >
            {{ addTypeButtonName }}
          </sui-button>
          <sui-button
            v-permission:download="$options.name"
            type="button"
            class="comm_btn_gridTop comm_ico_excel"
            @click="onClickExcelDown"
          >
            {{ $t('MSG_BTN_EXCEL_DOWN') }}
          </sui-button>
        </div>
      </sui-grid>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickAllLocationInfoExcel"
        >
          {{ $t('MSG_BTN_SITE_LCT_EXCEL_DOWN') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="locationTreePopup"
        >
          {{ $t('MSG_BTN_LOC_TREE_SRCH') }}
        </sui-button>
        <sui-button
          v-permission:update="$options.name"
          type="button"
          class="comm_btn_solid"
          @click="onClickSave"
        >
          {{ $t('MSG_BTN_SAVE') }}
        </sui-button>
      </div>
    </sui-page-contents>

    <sui-popup
      v-model="isShownAddPopup"
      :title="addTitle"
    >
      <container
        :is="addComponent"
        :pageId="$options.name"
        :siteId="siteId"
        :siteName="siteName"
        :optionList="optionList"
        :jobDistrictId="jobDistrictId"
        :buildingId="buildingId"
        :headquarterBuildingId="headquarterBuildingId"
        @closePopup="closePopup('isShownAddPopup')"
        @onClickSearch="onClickSearch()"
        @dataSelected="dataSelected"
      />
    </sui-popup>

    <sui-popup
      v-model="isShownModPopup"
      :title="modTitle"
    >
      <container
        :is="setModComponent"
        :pageId="$options.name"
        :siteId="siteId"
        :buildingId="buildingId"
        :selectedData="selectedData"
        :headquarterBuildingId="headquarterBuildingId"
        @closePopup="closePopup('isShownModPopup')"
        @onClickSearch="onClickSearch()"
        @setSelectBox="setSelectBox()"
      />
    </sui-popup>
  </sui-page>
</template>
<script>
import p01 from './components/PGE_CMY_00007_P01';
import p02 from './components/PGE_CMY_00007_P02';
import p03 from './components/PGE_CMY_00007_P03';
import p04 from './components/PGE_CMY_00007_P04';
import p05 from './components/PGE_CMY_00007_P05';
import p06 from './components/PGE_CMY_00007_P06';
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

const dateFields = [
  'firstRegistrationDTM', 'finalModificationDTM', 'pageUsePriodStartDatetime', 'pageUsePriodFinishDatetime',
];
export default {
  name: 'PGE_CMY_00007', // eslint-disable-line vue/name-property-casing
  components: {
    p01, p02, p03, p04, p05, p06,
  },
  extends: BasePage,
  data() {
    return {
      allLocationInfo: [],
      optionList: {
        COD_SITE: [],
        COD_DSRT: [],
        COD_BUIL: [],
        COD_LCT_TYPE: [],
      },
      siteId: '',
      siteName: '',
      jobDistrictId: '',
      buildingId: '',
      headquarterBuildingId: '',
      selectedBuildingId: '',
      selectedData: {},
      setModComponent: p04,
      frame0: {
        selectedCode: {
          COD_SITE: {
            key: '',
            label: '',
          },
          COD_DSRT: {
            key: 'ALL',
            label: '',
          },
          COD_BUIL: {
            key: 'ALL',
            label: '',
          },
          COD_USE: {
            key: '',
            label: '',
          },
        },
        locationName: '',
        locationEnglishName: '',
      },
      modTitle: this.$t('MSG_TIT_DSRT_DTL'),
      addTitle: this.$t('MSG_TIT_HDQT_DSRT_SRCH'),
      isShownAddPopup: false,
      isShownModPopup: false,
      addComponent: '',
      addTypeButtonName: this.$t('MSG_BTN_DSRT_ADD'),
      localdata0: [],
      localdata1: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_GEHS_LOC_ID'),
        datafield: 'locationId',
        width: '150px',
      }, {
        text: this.$t('MSG_TXT_LCT_TYPE'),
        datafield: 'locationTypeName',
        width: '150px',
      }, {
        text: this.$t('MSG_TXT_LCT_NM'),
        datafield: 'locationName',
        // datafield: 'locationNameButton',
        cellClassName: 'BL_textlink cursor',
        // createwidget: (row, column, value, htmlElement) => {
        //   utils.getGridCellFactory().createCellButtonList(row, column, value, htmlElement, {
        //     handler: this.onClickName,
        //   }, this.dsLocation, this.$refs.grid);
        // },
        // initwidget(row, column, value, htmlElement) {
        //   utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        // },
      }, {
        text: this.$t('MSG_TXT_LCT_EN_NM'),
        datafield: 'locationEnglishName',
        // datafield: 'locationEnglishNameButton',
        cellClassName: 'BL_textlink cursor',
        // createwidget: (row, column, value, htmlElement) => {
        //   utils.getGridCellFactory().createCellButtonList(row, column, value, htmlElement, {
        //     handler: this.onClickName,
        //   }, this.dsLocation, this.$refs.grid);
        // },
        // initwidget(row, column, value, htmlElement) {
        //   utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        // },
      }, {
        text: this.$t('MSG_TXT_ARRAY_ORDER'),
        datafield: 'arrayalOrder',
        width: '80px',
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'locationUseName',
        width: '80px',
      }, {
        text: this.$t('MSG_TXT_HDQT_LOC_ID'),
        datafield: 'headquarterLocationId',
        width: '200px',
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'finalModificationUserId',
        width: '200px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1', // "1", "2" - default: "1"
            type: 'link', // 'link', 'sublink' - default: "link"
          }, this.dsLocation, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        width: '150px',
      }],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsLocation',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { name: 'rowType', type: 'string', map: 'rowType' },
      { name: 'dataset-row-id', type: 'string', map: 'dataset-row-id' },
      { name: 'arrayalOrder', type: 'string', map: 'arrayalOrder' },
      { name: 'siteId', type: 'string', map: 'siteId' },
      { name: 'originalFinalModificationDTM', type: 'string', map: 'originalFinalModificationDTM' },
      { name: 'locationUseYn', type: 'string', map: 'locationUseYn' },
      { name: 'locationTypeCode', type: 'string', map: 'locationTypeCode' },
      { name: 'finalModificationDTM', type: 'string', map: 'finalModificationDTM' },
      { name: 'finalModificationProgramId', type: 'string', map: 'finalModificationProgramId' },
      { name: 'finalModificationUserId', type: 'string', map: 'finalModificationUserId' },
      { name: 'firstRegistrationDTM', type: 'string', map: 'firstRegistrationDTM' },
      { name: 'firstRegistrationProgramId', type: 'string', map: 'firstRegistrationProgramId' },
      { name: 'firstRegistrationUserId', type: 'string', map: 'firstRegistrationUserId' },
      { name: 'businessSectorDivisionCode', type: 'string', map: 'businessSectorDivisionCode' },
      { name: 'floorId', type: 'string', map: 'floorId' },
      { name: 'headquarterLocationId', type: 'string', map: 'headquarterLocationId' },
      { name: 'id', type: 'string', map: 'id' },
      { name: 'jobDistrictId', type: 'string', map: 'jobDistrictId' },
      { name: 'locationEnglishName', type: 'string', map: 'locationEnglishName' },
      { name: 'locationId', type: 'string', map: 'locationId' },
      { name: 'locationName', type: 'string', map: 'locationName' },
      { name: 'locationNoteContent', type: 'string', map: 'locationNoteContent' },
      { name: 'buildingId', type: 'string', map: 'buildingId' },
      { name: 'headquarterSiteId', type: 'string', map: 'headquarterSiteId' },
      { name: 'locationNameButton', type: 'string', map: 'locationNameButton' },
      { name: 'locationEnglishNameButton', type: 'string', map: 'locationEnglishNameButton' },
      { name: 'locationTypeName', type: 'string', map: 'locationTypeName' },
      { name: 'knoxId', type: 'string', map: 'knoxId' },
      { name: 'userName', type: 'string', map: 'userName' },
      { name: 'userGlobalName', type: 'string', map: 'userGlobalName' },
      { name: 'departmentName', type: 'string', map: 'departmentName' },
      { name: 'departmentEnglishName', type: 'string', map: 'departmentEnglishName' },
      { name: 'displayLanguageId', type: 'string', map: 'displayLanguageId' },
      { name: 'locationUseName', type: 'string', map: 'locationUseName' },
      { name: 'excelModificationUserName', type: 'string', map: 'excelModificationUserName' },
    ],
  }, {
    id: 'dsAllLocationInfo',
    type: 'local',
    data: 'localdata1',
    datafields: [
      { name: 'locationId', type: 'string', map: 'locationId' },
      { name: 'siteName', type: 'string', map: 'siteName' },
      { name: 'locationTypeName', type: 'string', map: 'locationTypeName' },
      { name: 'jobDistrictId', type: 'string', map: 'jobDistrictId' },
      { name: 'buildingId', type: 'string', map: 'buildingId' },
      { name: 'locationName', type: 'string', map: 'locationName' },
      { name: 'locationEnglishName', type: 'string', map: 'locationEnglishName' },
      { name: 'arrayalOrder', type: 'string', map: 'arrayalOrder' },
      { name: 'locationNoteContent', type: 'string', map: 'locationNoteContent' },
      { name: 'headquarterSiteName', type: 'string', map: 'headquarterSiteName' },
      { name: 'headquarterFloorEnglishName', type: 'string', map: 'headquarterFloorEnglishName' },
      { name: 'headquarterBuildingName', type: 'string', map: 'headquarterBuildingName' },
      { name: 'buildingRepresentativeDivisionCode', type: 'string', map: 'buildingRepresentativeDivisionCode' },
      { name: 'jobDistrictEnglishName', type: 'string', map: 'jobDistrictEnglishName' },
      { name: 'jobDistrictName', type: 'string', map: 'jobDistrictName' },
      { name: 'headquarterLocationId', type: 'string', map: 'headquarterLocationId' },
      { name: 'locationUseYn', type: 'string', map: 'locationUseYn' },
      { name: 'finalModificationDTM', type: 'string', map: 'finalModificationDTM' },
      { name: 'knoxId', type: 'string', map: 'knoxId' },
      { name: 'representativeBuildingId', type: 'string', map: 'representativeBuildingId' },
      { name: 'floorCount', type: 'string', map: 'floorCount' },
      { name: 'buildingTypeName', type: 'boolean', map: 'buildingTypeName' },
      { name: 'buildingUseName', type: 'string', map: 'buildingUseName' },
      { name: 'gisXValue', type: 'string', map: 'gisXValue' },
      { name: 'gisYValue', type: 'string', map: 'gisYValue' },
      { name: 'buildingNoteContent', type: 'string', map: 'buildingNoteContent' },
      { name: 'headquarterFloorId', type: 'string', map: 'headquarterFloorId' },
      { name: 'headquarterFloorName', type: 'string', map: 'headquarterFloorName' },
      { name: 'headquarterFloorEnglishName', type: 'string', map: 'headquarterFloorEnglishName' },
      { name: 'gisXStartValue', type: 'string', map: 'gisXStartValue' },
      { name: 'gisXFinishValue', type: 'string', map: 'gisXFinishValue' },
      { name: 'gisYStartValue', type: 'string', map: 'gisYStartValue' },
      { name: 'gisYFinishValue', type: 'string', map: 'gisYFinishValue' },
      { name: 'gisLayerNumber', type: 'string', map: 'gisLayerNumber' },
      { name: 'floorNoteContent', type: 'string', map: 'floorNoteContent' },
    ],
  }],
  mounted() {
    this.$nextTick(() => {
      this.commCodeSelect();
      this.setSessionSite();
      this.setOptionList('site');
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    // 공통 코드 메소드
    commCodeSelect() {
      const CODE_KEYS = ['COD_LCT_TYPE'];
      return http.mergeCodeList(this.$options.name, CODE_KEYS, this.optionList);
    },
    /**
     *  사업장 기본 값
     *  사용자 세션 사업장으로 설정
     */
    setSessionSite() {
      // 사용자 세션 사업장 코드 값 설정 -> 세션설정 정보가 없을 경우 수원(C100SW)로 지정(임시)
      const sessionSiteId = this.$store.getters.userInfo.siteId;
      this.frame0.selectedCode.COD_SITE.key = utils.isEmpty(sessionSiteId) || utils.isUndefined(sessionSiteId)
        ? 'C100SW'
        : sessionSiteId;
    },
    /**
     *  엑셀 다운로드
     */
    onClickExcelDown() {
      const columns = [{
        text: this.$t('MSG_TXT_GEHS_LOC_ID'),
        datafield: 'locationId',
      }, {
        text: this.$t('MSG_TXT_LCT_TYPE'),
        datafield: 'locationTypeName',
      }, {
        text: this.$t('MSG_TXT_LCT_NM'),
        datafield: 'locationName',
      }, {
        text: this.$t('MSG_TXT_LCT_EN_NM'),
        datafield: 'locationEnglishName',
      }, {
        text: this.$t('MSG_TXT_ARRAY_ORDER'),
        datafield: 'arrayalOrder',
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'locationUseName',
      }, {
        text: this.$t('MSG_TXT_HDQT_LOC_ID'),
        datafield: 'headquarterLocationId',
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'excelModificationUserName',
      }, {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
      }];

      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `location_${sToday}.xlsx`;
      utils.downloadGridToExcel(this.$options.name, columns, this.dsLocation, sExcelName);
    },
    /**
     *  검색
     *  위치정보 목록 조회
     */
    onClickSearch() {
      this.siteId = this.frame0.selectedCode.COD_SITE.key;
      this.siteName = this.$refs.siteSelect.currentSelected.label;
      this.jobDistrictId = this.frame0.selectedCode.COD_DSRT.key;
      this.buildingId = this.frame0.selectedCode.COD_BUIL.key;
      this.headquarterBuildingId = this.selectedBuildingId;

      const queryParams = {
        siteId: this.siteId,
        jobDistrictId: this.jobDistrictId,
        buildingId: this.buildingId,
        locationUseYn: this.frame0.selectedCode.COD_USE.key,
        locationEnglishName: this.frame0.locationEnglishName,
        locationName: this.frame0.locationName,
        locationId: '',
      };

      http.request(this.$options.name, 'DTS_CMY_00030', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateFields);
        utils.forEach(res.data, (obj, key) => {
          // 위치명, 위치영문명 button 옵션 설정
          // const locEnName = [{
          //   label: obj.locationEnglishName,
          //   key: obj.locationTypeCode,
          //   type: 'sublink',
          // }];
          // const locName = [{
          //   label: obj.locationName,
          //   key: obj.locationTypeCode,
          //   type: 'sublink',
          // }];

          // res.data[key].locationEnglishNameButton = locEnName;
          // res.data[key].locationNameButton = locName;

          // 엑셀다운로드용 수정자 컬럼 생성
          const displayLnaguageUserName = utils.isEqual(obj.displayLanguageId, this.$store.getters.userInfo.langId)
            ? obj.userName
            : obj.userGlobalName;
          const userName = utils.isEmpty(displayLnaguageUserName) ? '' : displayLnaguageUserName;
          const knoxId = utils.isEmpty(obj.knoxId) ? '' : obj.knoxId;
          const excelModificationUserName = utils.isEmpty(userName) && utils.isEmpty(knoxId)
            ? ''
            : `${userName}/${knoxId}`;
          res.data[key].excelModificationUserName = `${excelModificationUserName}`;
        });

        this.dsLocation.setRawData(res.data);

        // 추가 버튼 name component set
        this.setAddTypeButtonName();
        this.setAddComponent();
      });
    },
    /**
     *  위치정보 트리 조회
     */
    locationTreePopup() {
      utils.openLayerPopup('PGE_CMY_00008', null, {
        pageInitialData: { readonly: false },
        size: 'md',
        title: this.$t('MSG_TIT_LCT_SRCH'),
      });
    },
    /**
     *  팝업 호출
     */
    callPopup(popupName) {
      if (utils.isEqual(popupName, 'isShownAddPopup') && utils.isEmpty(this.addComponent)) {
        utils.messageBox('warning', this.$t('MSG_ALT_SRCH_NOT_ADD'));
        return false;
      }
      this[popupName] = true;

      return null;
    },
    /**
     *  팝업 닫기
     */
    closePopup(popupName) {
      this[popupName] = false;
    },
    /**
     *  팝업 CALLBACK
     *  팝업 type에 따른 ROW 추가
     */
    dataSelected(data, type) {
      const dataList = [];
      let defaultRow = {};
      let code = {};

      utils.forEach(data, obj => {
        switch (type) {
          case '01':
            code = utils.find(this.optionList.COD_LCT_TYPE, { key: '01' });
            defaultRow = {
              rowType: 'insert',
              arrayalOrder: obj.arrayalOrder,
              siteId: this.siteId,
              locationUseYn: 'Y',
              locationUseName: 'Yes',
              locationTypeCode: type,
              floorId: '',
              buildingId: '',
              jobDistrictId: '',
              locationTypeName: code.label,
              headquarterLocationId: obj.headquarterJobDistrictId,
              businessSectorDivisionCode: obj.businessSectorDivisionCode,
              locationEnglishName: obj.jobDistrictEnglishName,
              locationName: obj.jobDistrictName,
              locationNoteContent: obj.jobDistrictNoteContent,
              headquarterSiteId: obj.headquarterSiteId,
              locationEnglishNameButton: [{
                label: obj.jobDistrictEnglishName,
                key: type,
                type: 'sublink',
              }],
              locationNameButton: [{
                label: obj.jobDistrictName,
                key: type,
                type: 'sublink',
              }],
            };
            break;
          case '02':
            code = utils.find(this.optionList.COD_LCT_TYPE, { key: '02' });
            defaultRow = {
              rowType: 'insert',
              arrayalOrder: obj.arrayalOrder,
              siteId: this.siteId,
              locationUseYn: 'Y',
              locationUseName: 'Yes',
              locationTypeCode: type,
              floorId: '',
              buildingId: '',
              locationTypeName: code.label,
              jobDistrictId: this.jobDistrictId,
              headquarterLocationId: obj.headquarterBuildingId,
              businessSectorDivisionCode: obj.businessSectorDivisionCode,
              locationEnglishName: obj.headquarterBuildingEnglishName,
              locationName: obj.headquarterBuildingName,
              locationNoteContent: obj.buildingNoteContent,
              headquarterSiteId: obj.headquarterSiteId,
              locationEnglishNameButton: [{
                label: obj.headquarterBuildingEnglishName,
                key: type,
                type: 'sublink',
              }],
              locationNameButton: [{
                label: obj.headquarterBuildingName,
                key: type,
                type: 'sublink',
              }],
            };
            break;
          case '03':
            code = utils.find(this.optionList.COD_LCT_TYPE, { key: '03' });
            defaultRow = {
              rowType: 'insert',
              arrayalOrder: obj.arrayalOrder,
              siteId: this.siteId,
              locationUseYn: 'Y',
              locationUseName: 'Yes',
              locationTypeCode: type,
              floorId: '',
              locationTypeName: code.label,
              buildingId: this.buildingId,
              jobDistrictId: this.jobDistrictId,
              headquarterLocationId: obj.headquarterLocationId,
              businessSectorDivisionCode: obj.businessSectorDivisionCode,
              locationEnglishName: obj.headquarterFloorEnglishName,
              locationName: obj.headquarterFloorName,
              locationNoteContent: obj.buildingNoteContent,
              headquarterSiteId: obj.headquarterSiteId,
              locationEnglishNameButton: [{
                label: obj.headquarterFloorEnglishName,
                key: type,
                type: 'sublink',
              }],
              locationNameButton: [{
                label: obj.headquarterFloorName,
                key: type,
                type: 'sublink',
              }],
            };
            break;
          default:
            break;
        }
        const duplicationCheck = utils.findIndex(this.dsLocation.data,
          o => utils.isEqual(o.headquarterLocationId, defaultRow.headquarterLocationId)) > -1;

        if (!duplicationCheck) dataList.push(defaultRow);
      });

      this.dsLocation.addRows(dataList);
    },
    /**
     *  저장
     */
    onClickSave() {
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.$options.name, 'DTS_CMY_00046', {
          data: this.dsLocation.data,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, () => {
            this.onClickSearch();
            this.setSelectBox();
          });
        });
      });
    },
    /**
     *  리셋
     */
    onClickReset() {
      utils.forEach(this.frame0, (value, key) => {
        if (!utils.isEqual(key, 'selectedCode')) {
          this.frame0[key] = '';
        } else {
          this.setSessionSite();
          this.$refs.jobDistrict.reset();
          this.$refs.building.reset();
          this.$refs.useYn.reset();
        }
      });
    },
    /**
     *  grid
     *  위치정보 click event
     */
    onClickName(btn, dataRow) {
      if (utils.isEqual(dataRow.rowType, 'insert')) {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_DTL_INFO'));
        return false;
      }
      switch (dataRow.locationTypeCode) {
        case '01':
          this.modTitle = this.$t('MSG_TIT_DSRT_DTL');
          this.setModComponent = p04;
          break;
        case '02':
          this.modTitle = this.$t('MSG_TIT_BUIL_DTL');
          this.setModComponent = p05;
          break;
        case '03':
          this.modTitle = this.$t('MSG_TIT_BUIL_FLOR_DTL');
          this.setModComponent = p06;
          break;
        default:
          break;
      }

      this.selectedData = dataRow;
      this.callPopup('isShownModPopup');

      return null;
    },
    /**
     *  검색조건
     *  selectBox refresh
     */
    setSelectBox() {
      if (utils.isEqual(this.jobDistrictId, 'ALL') && utils.isEqual(this.buildingId, 'ALL')) {
        this.setOptionList('site');
      } else if (!utils.isEqual(this.jobDistrictId, 'ALL') && utils.isEqual(this.buildingId, 'ALL')) {
        this.setOptionList('jobDistrict');
      }
    },
    /**
     *  검색조건
     *  '단지명', '건물명'
     *  selectBox 항목 생성
     */
    setOptionList(type, selectedValue) {
      const jobDistrictId = utils.isEqual(type, 'jobDistrict') ? this.frame0.selectedCode.COD_DSRT.key : '';
      const queryParams = {
        siteId: this.frame0.selectedCode.COD_SITE.key,
        jobDistrictId,
      };

      if (utils.isEqual(type, 'site')) this.frame0.selectedCode.COD_DSRT.key = 'ALL';
      this.frame0.selectedCode.COD_BUIL.key = 'ALL';

      http.request(this.$options.name, 'DTS_CMY_00031', {
        query: queryParams,
      }).then(res => {
        const optionList = [];

        if (utils.isEqual(type, 'site')) {
          utils.forEach(res.data, obj => {
            const option = {
              key: obj.locationId,
              label: obj.locationName,
            };
            optionList.push(option);
          });
          this.optionList.COD_DSRT = optionList;
          this.optionList.COD_BUIL = [];
        } else if (utils.isEqual(type, 'jobDistrict')) {
          utils.forEach(res.data, obj => {
            const option = {
              key: obj.locationId,
              label: obj.locationName,
              headquarterBuildingId: obj.headquarterLocationId,
            };
            optionList.push(option);
          });
          if (selectedValue) {
            if (utils.isEqual(selectedValue.key, 'ALL')) {
              this.optionList.COD_BUIL = [];
            } else {
              this.optionList.COD_BUIL = optionList;
            }
          } else {
            this.optionList.COD_BUIL = optionList;
          }
        }
      });
    },
    /**
     *  '추가' 버튼명 변경
     */
    setAddTypeButtonName() {
      if (utils.isEqual(this.jobDistrictId, 'ALL') && utils.isEqual(this.buildingId, 'ALL')) {
        this.addTypeButtonName = this.$t('MSG_BTN_DSRT_ADD');
      } else if (!utils.isEqual(this.jobDistrictId, 'ALL') && utils.isEqual(this.buildingId, 'ALL')) {
        this.addTypeButtonName = this.$t('MSG_BTN_BUIL_ADD');
      } else {
        this.addTypeButtonName = this.$t('MSG_BTN_FLOR_ADD');
      }
    },
    /**
     *  '추가' 호출 될 팝업 type 변경
     */
    setAddComponent() {
      if (utils.isEqual(this.jobDistrictId, 'ALL') && utils.isEqual(this.buildingId, 'ALL')) {
        this.addComponent = p01;
        this.addTitle = this.$t('MSG_TIT_HDQT_DSRT_SRCH');
      } else if (!utils.isEqual(this.jobDistrictId, 'ALL') && utils.isEqual(this.buildingId, 'ALL')) {
        this.addComponent = p02;
        this.addTitle = this.$t('MSG_TIT_HDQT_BUIL_SRCH');
      } else {
        this.addComponent = p03;
        this.addTitle = this.$t('MSG_TIT_HDQT_FLOR_SRCH');
      }
    },
    /**
     *  건물 ID
     */
    setBulidId(data) {
      this.selectedBuildingId = data.headquarterBuildingId;
    },
    /**
     *  사업장 별 위치 엑셀 다운
     *  Button Click Event
     */
    onClickAllLocationInfoExcel() {
      this.selectAllLocationInfo();
    },
    /**
     *  사업장 기준
     *  전체 위치정보 조회
     */
    selectAllLocationInfo() {
      http.request(this.$options.name, 'DTS_CMY_00089', {
        path: {
          'site-id': this.frame0.selectedCode.COD_SITE.key,
        },
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateFields);
        this.dsAllLocationInfo.setRawData(res.data);
        this.locationListSort();
      });
    },
    /**
     * parentsId가 없는 데이터(단지) 기준으로 정렬 시작.
     */
    locationListSort() {
      const lvl1 = utils.clone(utils.filter(this.dsAllLocationInfo.data, o => utils.isEmpty(o.parentsId)));
      this.allLocationInfo = [];
      this.findChild(lvl1, '1').then(result => {
        this.dsAllLocationInfo.setRawData(result);
        this.allLocationInfoExcelDown();
      });
    },
    /**
     *  데이터 정렬
     *  부모 row 아래 자식 row 삽입
     */
    findChild(data, level) {
      if (utils.isEqual(level, '3')) {
      // 3레벨은 최하위 레벨 데이터로 자식 데이터 찾을 필요가 없으므로 바로 array 병합
        utils.concat(this.allLocationInfo, level);
      } else {
        utils.forEach(data, value => {
          const list = utils.clone(utils.filter(this.dsAllLocationInfo.data,
            o => utils.isEqual(o.parentsId, value.locationId)));
          this.allLocationInfo.push(value);
          // 자식데이터가 존재하면 다시 호출.
          if (utils.size(list) > 0) {
            this.findChild(list, level + 1);
          }
        });
      }
      return new Promise(resolve => {
        resolve(this.allLocationInfo);
      });
    },
    /**
     *  사업장 기준 위치정보 엑셀 다운로드
     */
    allLocationInfoExcelDown() {
      const columns = [{
        text: this.$t('MSG_TXT_LCT_ID'),
        datafield: 'locationId',
      }, {
        text: this.$t('MSG_TXT_SITE_NM'),
        datafield: 'siteName',
      }, {
        text: this.$t('MSG_TXT_LCT_TYPE'),
        datafield: 'locationTypeName',
      }, {
        text: this.$t('MSG_TXT_DSRT_ID'),
        datafield: 'jobDistrictId',
      }, {
        text: this.$t('MSG_TXT_BUIL_ID'),
        datafield: 'buildingId',
      }, {
        text: this.$t('MSG_TXT_LCT_NM'),
        datafield: 'locationName',
      }, {
        text: this.$t('MSG_TXT_LCT_EN_NM'),
        datafield: 'locationEnglishName',
      }, {
        text: this.$t('MSG_TXT_ARRAY_ORDER'),
        datafield: 'arrayalOrder',
      }, {
        text: this.$t('MSG_TXT_LCT_CNTN'),
        datafield: 'locationNoteContent',
      }, {
        text: this.$t('MSG_TXT_BIZ_SECT_DIV'),
        datafield: 'businessSectorDivisionName',
      }, {
        text: this.$t('MSG_TXT_HDQT_SITE_ABBR'),
        datafield: 'headquarterSiteName',
      }, {
        text: this.$t('MSG_TXT_HDQT_LOC_ID'),
        datafield: 'headquarterLocationId',
      }, {
        text: this.$t('MSG_TXT_LCT_USE_YN'),
        datafield: 'locationUseYn',
      }, {
        text: this.$t('MSG_TXT_FNL_MDFC_DTM'),
        datafield: 'finalModificationDTM',
      }, {
        text: this.$t('MSG_TXT_MDFC_USR_ID'),
        datafield: 'knoxId',
      }, {
        text: this.$t('MSG_TXT_HDQT_DSRT_NM'),
        datafield: 'jobDistrictName',
      }, {
        text: this.$t('MSG_TXT_HDQT_DSRT_EN_NM'),
        datafield: 'jobDistrictEnglishName',
      }, {
        text: this.$t('MSG_TXT_HDQT_BUIL_NM'),
        datafield: 'headquarterBuildingName',
      }, {
        text: this.$t('MSG_TXT_HDQT_BUIL_EN_NM'),
        datafield: 'headquarterFloorEnglishName',
      }, {
        text: this.$t('MSG_TXT_RPRS_BUIL_DIV'),
        datafield: 'buildingRepresentativeDivisionCode',
      }, {
        text: this.$t('MSG_TXT_RPRS_BUIL_ID'),
        datafield: 'representativeBuildingId',
      }, {
        text: this.$t('MSG_TXT_FLOR_CNT'),
        datafield: 'floorCount',
      }, {
        text: this.$t('MSG_TXT_BUIL_TYPE'),
        datafield: 'buildingTypeName',
      }, {
        text: this.$t('MSG_TXT_BUIL_USE'),
        datafield: 'buildingUseName',
      }, {
        text: this.$t('MSG_TXT_GIS_X_CODN'),
        datafield: 'gisXValue',
      }, {
        text: this.$t('MSG_TXT_GIS_Y_CODN'),
        datafield: 'gisYValue',
      }, {
        text: this.$t('MSG_TXT_BUIL_CNTN'),
        datafield: 'buildingNoteContent',
      }, {
        text: this.$t('MSG_TXT_HDQT_FLOR_ID'),
        datafield: 'headquarterFloorId',
      }, {
        text: this.$t('MSG_TXT_HDQT_FLOR_NM'),
        datafield: 'headquarterFloorName',
      }, {
        text: this.$t('MSG_TXT_HDQT_FLOR_EN_NM'),
        datafield: 'headquarterFloorEnglishName',
      }, {
        text: this.$t('MSG_TXT_GIS_X_CODN_START'),
        datafield: 'gisXStartValue',
      }, {
        text: this.$t('MSG_TXT_GIS_X_CODN_END'),
        datafield: 'gisXFinishValue',
      }, {
        text: this.$t('MSG_TXT_GIS_Y_CODN_START'),
        datafield: 'gisYStartValue',
      }, {
        text: this.$t('MSG_TXT_GIS_Y_CODN_END'),
        datafield: 'gisYFinishValue',
      }, {
        text: this.$t('MSG_TXT_GIS_LAYER_NO'),
        datafield: 'gisLayerNumber',
      }, {
        text: this.$t('MSG_TXT_FLOR_CNTN'),
        datafield: 'floorNoteContent',
      }];
      utils.downloadGridToExcel(this.$options.name, columns, this.dsAllLocationInfo, 'allLocation.xlsx');
    },
    /** **************************
      함수 영역 : Grid Event
     **************************** */
    onClickGrid(event) {
      console.log(event.args.row.bounddata);
      if (event.args.datafield === 'locationName' || event.args.datafield === 'locationEnglishName') {
        this.onClickName(event.args.row.bounddata[event.args.datafield], event.args.row.bounddata);
      }
    },
  },
};
</script>
<style scoped>
</style>
